import { render, staticRenderFns } from "./InputDialog.vue?vue&type=template&id=1a5a2ab2&"
import script from "./InputDialog.vue?vue&type=script&lang=js&"
export * from "./InputDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports